/**
 * Created by Jie Gao on 2019-01-18.
 */
export class StarStruckGameMode {
    public static readonly STAR_PICK:string = "STAR_PICK_SELECTION";
}